<template>
  <v-dialog
    v-model="show"
    :width="$isMobile() ? '100%' : 'max-content'"
  >
    <v-card
      class="modal-invoice-details"
      background-color="#f5f5f5"
      flat
    >
      <v-toolbar
        color="primary"
        dark
        flat
      >
        <v-toolbar-title>DETALHES DA NOTA FISCAL</v-toolbar-title>
        <v-spacer />
        <v-btn
          @click="close()"
          icon
        >
          <v-icon>close</v-icon>
        </v-btn>
      </v-toolbar>
      <v-layout
        row
        wrap
      >
        <v-card
          flat
          class="card-invoice"
        >
          <v-card-text class="d-flex header-nf">
            <div class="mr-3 pr-3 info-nf">
              NFe: <b>{{ detailsInformation.invoiceNumber }}</b>
              <span class="ml-2">Série: <b>{{ detailsInformation.serialNumber }}</b></span>
              <br>
              <span class="gray--text text--lighten-1">{{ detailsInformation.emitterName }}</span>
            </div>
            <div class="info-nf ml-3">
              <span class="gray--text text--lighten-1">Vendedor</span>
              <br>
              {{ detailsInformation.seller }}
            </div>
            <div class="info-nf mr-2 ml-3">
              <span class="gray--text text--lighten-1">Emissão</span>
              <br>
              {{ $date(detailsInformation.issuedAt) }}
            </div>
            <div class="invoice-status">
              <span class="gray--text text--lighten-1">Total de itens: </span>
              <span class="status-icon">
                <v-icon class="green--text">verified</v-icon>
              </span>
              <span class="status-title">{{ getCountStatusItems.valid ? getCountStatusItems.valid : 0 }}</span>

              <span class="status-icon ml-3">
                <v-icon class="orange--text">watch_later</v-icon>
              </span>
              <span class="status-title">{{ getCountStatusItems.pending ? getCountStatusItems.pending : 0 }}</span>

              <span class="status-icon ml-3">
                <v-icon class="red--text">error</v-icon>
              </span>
              <span class="status-title">{{ getCountStatusItems.rejected ? getCountStatusItems.rejected : 0 }}</span>
            </div>
          </v-card-text>
          <AppBody
            :headers="headers"
            :items="productsItems"
          />
        </v-card>
      </v-layout>
    </v-card>
  </v-dialog>
</template>

<script>
import AppBody from '@/components/ui/AppBody'

export default {
  name: 'InvoiceDetailsModal',

  components: {
    AppBody
  },

  data: () => ({
    show: false,
    detailsInformation: {},
  }),

  computed: {
    getCountStatusItems() {
      const items = this.detailsInformation.products || []

      const statusItems = items?.reduce((statusItems, obj) => {
        statusItems[obj.status] = (statusItems[obj.status] || 0) + 1
        return statusItems
      }, {})

      return statusItems || {}
    },
    headers() {
      return [
        {
          text: 'Descrição',
          sortable: false,
          formatter: ({ description }) => description
        },
        {
          text: 'Produto campanha',
          sortable: false,
          formatter: ({ partnersPremiumProduct }) => partnersPremiumProduct || 'Não é da campanha'
        },
        {
          text: 'Quantidade Informada',
          sortable: false,
          formatter: ({ partnersPremiumQuantity }) => {
            return partnersPremiumQuantity ? partnersPremiumQuantity + ' KG' : '-'
          }
        },
        {
          text: 'Qtd. / Unidade da Nota',
          sortable: false,
          formatter: ({ invoiceQuantity, invoiceKPI }) => {
            return invoiceQuantity ? invoiceQuantity + ' ' + invoiceKPI : '-'
          }
        },
        {
          text: 'SDZ',
          sortable: false,
          formatter: ({ coins }) => coins || 0
        },
        {
          text: 'Situação',
          sortable: false,
          icon: ({ status }) => (this.statusIcon(status)),
          formatter: ({ status }) => {
            switch (status) {
              case 'rejected':
                return 'Rejeitado'
              case 'valid':
                return 'Aprovado'
              default:
                return 'Pendente'
            }
          }
        },
        {
          text: 'Motivo',
          sortable: false,
          formatter: ({ refusalReason }) => {
            return refusalReason || '-'
          }
        }
      ]
    },
    productsItems() {
      return this.detailsInformation.products || []
    }
  },

  methods: {
    open(item) {
      this.detailsInformation = item || {}
      this.show = true
    },

    close() {
      this.show = false
    },

    statusIcon(status) {
      const statusOptions = {
        rejected: {
          type: 'error',
          color: 'red--text'
        },
        valid: {
          type: 'verified',
          color: 'green--text'
        },
        pending: {
          type: 'watch_later',
          color: 'orange--text'
        }
      }

      return statusOptions[status]
    }
  }
}
</script>

<style lang="stylus">
.modal-invoice-details
  .card-invoice
    width: 100% !important;
  .elevation-1
    margin-bottom: 0px !important;

  .header-nf
    border-bottom: 1px solid var(--v-gray-base)

    .info-nf
      border-right: 1px solid var(--v-gray-base)

  .orange--text
    color: #ff9800!important;
    caret-color: #ff9800!important;

</style>
